import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { Clients } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Clients.Pages.CLIENTS}`,
    name: Clients.Pages.CLIENTS,
    component: () => import(/* webpackChunkName: "clients" */ './views/Clients.vue'),
    meta: {
      access_roles: RouteRoles[Clients.Pages.CLIENTS],
    },
  },
  {
    path: `/${Clients.Pages.CLIENT_DETAIL}/:id(\\d+)`,
    name: Clients.Pages.CLIENT_DETAIL,
    component: () => import(/* webpackChunkName: "client-detail" */ './views/ClientDetail.vue'),
    meta: {
      access_roles: RouteRoles[Clients.Pages.CLIENT_DETAIL],
    },
  },
  {
    path: `/${Clients.Pages.CLIENTS}/:id(\\d+)/edit`,
    name: Clients.Pages.CLIENT_EDIT,
    component: () => import(/* webpackChunkName: "client-edit" */ './views/ClientDetailEdit.vue'),
    meta: {
      access_roles: RouteRoles[Clients.Pages.CLIENT_EDIT],
    },
  },
];

export default routes;
